module.exports = __webpack_public_path__ + "media/sq_header_kdykoliv.5a74a686.mp4";